import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { OverlayPanel } from 'primeng/overlaypanel';
import { Subject, takeUntil } from 'rxjs';
import { EditProfileComponent } from 'src/app/pos-panel/components/edit-profile/edit-profile.component';
import { UserModel } from 'src/app/share-modul/models/user/user.model';
import { AuthenticationService } from 'src/app/share-modul/services/authentication/authentication.service';

@Component({
  selector: 'app-waiter-header',
  templateUrl: './waiter-header.component.html',
  styleUrls: ['./waiter-header.component.scss']
})
export class WaiterHeaderComponent implements OnInit {
 //#region Fields
  public unsubscribe: Subject<void> = new Subject<void>()
  public items: MenuItem[];
  public imagePath: string = './assets/images/logo/profile-picture-placeholder.png'
  public firstNameLastName: string;
  public email: string;
  public user: UserModel | null;
  public productList: Array<any> = new Array<any>();

  public isManager: boolean = false;
  public manager: boolean;
  public waiter: boolean;
  public venueId: string = '';

  @ViewChild('menu_products', { static: false }) menuProducts: OverlayPanel;
  @ViewChild('icon', { static: false }) toggleBtn: ElementRef;
  //#endregion
  //#region Constructor
  constructor(
    public dialogService: DialogService,
    public messageService: MessageService,
    public authenticationService: AuthenticationService,
    public translate: TranslateService,
    public _router: Router,
    public route: ActivatedRoute,
    public elementRef: ElementRef,
  ) {
    this.translate.stream('HEADER.APP_LANGUAGE').subscribe( () => {
      this.addFunctionToDropdownItems();
    });
  }

  ngOnInit(): void {
    this.venueId = this.route.firstChild?.snapshot.params['id'];
    this.loadProfileInfo();
  }
  //#endregion

  //#region Public Methods
  logOut() {
    this.authenticationService.logoutWaiter()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          localStorage.removeItem('waiter_access_token');
          localStorage.removeItem('waiter_refresh_token');
          this._router.navigate(['/waiter', this.venueId, 'pin']);
        },
        error: (errorResponse) => {
          localStorage.removeItem('waiter_access_token');
          localStorage.removeItem('waiter_refresh_token');
          this._router.navigate(['/waiter', this.venueId, 'pin']);
        }
      });
  }

  editProfile() {
    const ref = this.dialogService.open(EditProfileComponent, {
      header: this.translate.instant('HEADER.EDIT_PROFILE'),
      data: {
        isWaiter : true,
      },
      styleClass: 'dialog_long , ml_200, mb_15'
    });
    ref.onClose.subscribe((item: any) => {
      this.loadProfileInfo();
      if (item) {
        let summary = this.translate.instant("HEADER.PROFILE_UPDATED");
        this.messageService.add({severity: 'success', summary, life: 3000});
      }
    });
  }

  loadProfileInfo(): void {
    this.authenticationService.getWaiterProfile()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.firstNameLastName = response.firstName + ' ' + response.lastName;
          this.email = response.email;
          this.imagePath = response.profilePictureUrl ? response.profilePictureUrl : this.imagePath;
        },
        error: errorResponse => {
        }
      });
  }

  addFunctionToDropdownItems(): void {
    this.items = [
      {
        label: this.translate.instant('HEADER.EDIT_PROFILE'),
        command: () => {
          this.editProfile();
        }
      },
      {
        label: this.translate.instant('HEADER.END_SHIFT'),
        command: () => {
          this.logOut();
        }
      }
    ];
  }
  //#endregion

}
